import React from "react";
import { Trash2 } from "lucide-react";
import { formatDate } from "./utils";

const ReviewsTab = ({ reviews, onDelete }) => (
  <div className="bg-white border border-line overflow-x-auto" data-testid="admin-reviews-panel">
    <ul className="divide-y divide-line">
      {reviews.length === 0 ? (
        <li className="px-5 py-8 text-mute text-center">No reviews yet.</li>
      ) : (
        reviews.map((r) => (
          <li key={r.id} className="px-5 py-5 flex items-start justify-between gap-4">
            <div className="flex-1">
              <div className="flex items-center gap-3 mb-1">
                <span className="mono text-sm font-bold">{r.rating} ★</span>
                <span className="text-sm font-medium">{r.name}</span>
                <span className="mono text-xs text-mute">{formatDate(r.created_at)}</span>
              </div>
              {r.title && <p className="text-sm font-medium">{r.title}</p>}
              <p className="text-sm text-mute mt-1">{r.comment}</p>
            </div>
            <button
              type="button"
              onClick={() => onDelete(r.id)}
              className="text-mute hover:text-ink p-1"
              data-testid={`admin-delete-review-${r.id}`}
            >
              <Trash2 size={14} />
            </button>
          </li>
        ))
      )}
    </ul>
  </div>
);

export default ReviewsTab;
